// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`43.1|154.44500|131.8|159.19500|OST|H|N|
43.2|153.89000|131.8|159.06000|OST|H|N|
43.3|158.74500|131.8|158.74500|131.8|H|N|
43.4|154.26500|156.7|154.26500|156.7|L|N|
43.5|156.07500|156.7|156.07500|156.7|H|N|
43.5|151.38500|131.8|159.27000|OST|H|N|
43.6|151.16000|131.8|159.36000|OST|H|N|
43.8|151.32500|192.8|151.32500|192.8|L|N|
43.9|151.34000|192.8|151.34000|192.8|L|N|
43.10|151.37000|192.8|151.37000|192.8|L|N|
43.11|151.22000|192.8|151.22000|192.8|L|N|
43.12|159.26250|192.8|159.26250|192.8|L|N|
43.13|159.36750|192.8|159.36750|192.8|L|N|
43.14|151.35500|103.5|159.30000|OST|H|N|
43.15|151.26500|103.5|159.33000|OST|H|N|
43.16|151.40000|103.5|159.37500|OST|H|N|
43.17|172.22500|000.0|164.78750|OST|H|N|
43.18|171.47500|000.0|163.68750|OST|H|N|
43.19|170.55000|000.0|166.00000|OST|H|N|
43.20|169.90000|000.0|165.70000|OST|H|N|
43.21|167.47500|000.0|167.47500|000.0|L|N|
43.22|168.63750|000.0|168.63750|000.0|L|N|
43.23|168.05000|000.0|168.05000|000.0|L|N|
43.24|168.20000|000.0|168.20000|000.0|L|N|
43.25|168.60000|000.0|168.60000|000.0|L|N|
43.26|171.70000|000.0|165.60000|OST|H|N|
43.27|171.67500|000.0|165.60000|OST|H|N|
43.28|154.19000|100.0|154.43000|100.0|H|N|
43.29|159.79500|100.0|154.43000|100.0|H|N|
43.30|154.37000|173.8|153.95000|173.8|H|N|
43.31|154.31000|173.8|154.12250|173.8|H|N|
43.32|154.80000|173.8|159.00000|173.8|H|N|
43.33|154.77000|173.8|154.77000|173.8|L|N|
43.34|154.77750|173.8|154.77750|173.8|L|N|
43.35|154.83000|173.8|154.83000|173.8|L|N|
43.36|154.23500|103.5|153.83000|103.5|H|N|
43.37|156.00000|151.4|153.87500|151.4|H|N|
43.38|155.31750|103.5|153.77750|103.5|H|N|
43.39|154.07000|103.5|154.07000|103.5|L|N|
43.40|153.62000|100.0|159.73500|100.0|H|N|
43.41|153.84500|173.8|154.20500|173.8|H|N|
43.42|154.89750|100.0|156.08250|100.0|H|N|
43.43|155.03250|110.9|150.80500|103.5|H|N|
43.44|154.34000|110.9|154.34000|110.9|L|N|
43.45|155.05000|110.9|155.05000|110.9|L|N|
43.46|154.41500|000.0|156.06000|136.5|H|N|
43.47|154.17500|000.0|158.80500|136.5|H|N|
43.48|154.14500|000.0|158.86500|114.8|H|N|
43.49|155.94000|000.0|155.94000|000.0|L|N|
43.50|154.40000|114.8|156.16500|114.8|H|N|
43.51|152.64500|000.0|157.90500|141.3|H|N|
43.52|152.68500|000.0|157.93500|141.3|H|N|
43.53|151.10750|203.5|159.04500|203.5|H|N|
43.54|157.59000|000.0|157.59000|131.8|H|N|
43.55|160.05000|000.0|160.05000|131.8|H|N|
43.56|155.25000|146.2|150.77500|OST|H|N|
43.57|155.61000|146.2|150.79000|OST|H|N|
43.58|155.14500|146.2|155.14500|146.2|L|N|
43.59|151.47500|146.2|151.47500|146.2|L|N|
43.60|155.49750|146.2|155.49750|146.2|L|N|
43.61|155.69250|156.7|158.91000|156.7|H|N|
43.62|156.22500|156.7|159.01500|156.7|H|N|
43.63|153.96500|156.7|153.96500|156.7|L|N|
43.64|156.19500|156.7|156.19500|156.7|L|N|
43.65|154.78500|146.2|155.91750|OST|H|N|
43.66|155.35500|146.2|155.35500|146.2|H|N|
43.67|154.65000|156.7|159.15000|156.7|H|N|
43.68|151.13000|156.7|159.07500|156.7|H|N|
43.69|168.62500|000.0|168.62500|110.9|L|N|Emergency
44.1|151.17500|136.5|159.45000|000.0|H|N|TCU Local Net
44.2|151.13000|136.5|158.69250|000.0|H|N|Tuol Command Net
44.3|151.24250|103.5|159.26250|000.0|H|N|CDF Command 12
44.4|151.35500|103.5|159.30000|000.0|H|N|CDF Command 1
44.5|151.26500|103.5|159.33000|000.0|H|N|CDF Command 2
44.6|155.49000|136.5|155.49000|136.5|H|N|Tuolumne Tac
44.7|151.16000|192.8|151.16000|192.8|L|N|CDF Tac 2
44.8|151.25000|192.8|151.25000|192.8|L|N|CDF Tac 5
44.9|151.37000|192.8|151.37000|192.8|L|N|CDF Tac 8
44.10|156.07500|156.7|156.07500|156.7|H|N|CALCORD
44.11|151.22000|192.8|151.22000|192.8|L|N|CDF AIR/GROUND 1
44.12|159.26250|192.8|159.26250|192.8|L|N|CDF AIR/GROUND 2
44.13|159.36750|192.8|159.36750|192.8|L|N|CDF Air-to-Ground 3
44.14|151.66250|136.5|159.72750|000.0|H|N|CALAVERAS COMMAND
44.15|153.81500|192.8|153.81500|192.8|L|N|Calaveras Tac
44.16|154.26500|156.7|154.26500|156.7|L|N|Old White 2
44.17|154.29500|156.7|154.29500|156.7|L|N|Old White 3
44.18|154.30250|156.7|154.30250|156.7|L|N|VFIRE 26
44.19|154.32500|000.0|154.32500|000.0|H|N|Copper Fire Tac
44.20|154.23500|000.0|154.23500|000.0|H|N|Angel City Tac
44.21|155.28000|85.4|155.95500|85.4|H|N|Calaveras Health Net
44.22|155.29500|110.9|155.29500|110.9|L|N|Tuolumne Co Ambulance
44.23|170.50000|000.0|168.75000|000.0|H|N|USFS-STF Ops
44.24|172.77500|000.0|166.36250|000.0|H|N|Yosemite Fire
44.25|151.19000|146.2|159.22500|000.0|H|N|AEU Local Net
44.26|154.76250|123.0|159.18000|000.0|H|N|Amador Command
44.27|155.90250|186.2|159.27750|000.0|H|N|El Dorado Command
44.28|151.46000|123.0|159.39000|000.0|H|N|MMU Local Net 1
44.29|151.15250|123.0|159.33750|000.0|H|N|MMU Local Net 2 (NEW)
44.30|154.40000|123.0|159.04500|000.0|H|N|MERCED CO FIRE NET
44.31|153.09500|000.0|151.09500|000.0|H|N|Sierra Pacific
44.32|151.28000|110.9|000.00000|000.0||N|RX ONLY
44.33|151.29500|110.9|000.00000|000.0||N|RX ONLY
44.34|151.31000|110.9|000.00000|000.0||N|RX ONLY
44.35|151.27250|110.9|000.00000|000.0||N|RX ONLY
44.36|151.28750|110.9|000.00000|000.0||N|RX ONLY
44.37|151.30250|110.9|000.00000|000.0||N|RX ONLY
44.38|170.52500|110.9|000.00000|000.0||N|STF PRI AIR TAC RX ONLY
44.39|166.55000|000.0|166.55000|000.0|L|N|USFS RGN 5 TAC 4
44.40|167.11250|000.0|167.11250|000.0|L|N|USFS RGN 5 TAC 5
44.41|168.23750|000.0|168.23750|000.0|L|N|USFS RGN 5 TAC 6
44.42|153.77000|123.0|153.77000|123.0|H|N|Stan Co Dispatch Channel
44.43|154.43000|122 NAC|154.05500|122 NAC|H|N|CMD 2, P25 ID 37184, C4FM
44.44|154.43|123.0|154.05500|123.0|H|N|XST CMD 2 (ANALOG)
44.45|151.01000|82.5|153.87500|82.5|H|N|Stanislaus Co CMD 3
44.46|155.08500|NAC 124|156.09000|NAC 124|H|N|CMD4, P25 ID 37184, C4FM
44.47|155.08500|D464|156.09000|D464|H|N|XST COMMAND 4 (ANALOG)
44.48|155.94000|NAC 125|154.14500|NAC 125|H|N|P25 ID 37184, CQPSK
44.49|155.94000|123.0|154.14500|123.0|H|N|XST COMMAND 5 (ANALOG)
44.50|154.37000|NAC 127|154.37000|NAC 127|L|N|Tac 7, P25 ID 37184, C4FM
44.51|154.37000|123.0|154.37000|123.0|L|N|XST TAC 7 (ANALOG)
44.52|153.90500|NAC 128|153.90500|NAC 128|L|N|Tac 8, P25 ID 37184, C4FM
44.53|153.90500|123.0|153.90500|123.0|L|N|XST TAC 8 (ANALOG)
44.54|154.32500|NAC 129|154.32500|NAC 129|L|N|Tac 9, P25 ID 37184, C4FM
44.55|154.32500|123.0|154.32500|123.0|L|N|XST TAC 9 (ANALOG)
44.56|153.89000|NAC 130|153.89000|NAC 130|L|N|Tac 10, P25 ID 37184, C4FM
44.57|153.89000|123.0|153.89000|123.0|L|N|XST TAC 10 (ANALOG)
44.58|154.41500|NAC 131|154.41500|NAC 131|L|N|Tac 11, P25 ID 37184, C4FM
44.59|154.41500|D131|154.41500|D131|L|N|XST TAC 11 (ANALOG)
44.60|154.19000|NAC 132|154.19000|NAC 132|L|N|Tac 12, P25 ID 37184, C4FM
44.61|154.19000|123.0|154.19000|123.0|L|N|XST TAC 12 (ANALOG)
44.62|151.11500|D723|159.01500|D723|H|N|XST TAC 16 (Interop)
44.63|159.48000|110.9|152.97500|110.9|H|N|XSJ Control1 Disptach Net
44.64|155.89500|82.5|153.81500|82.5|H|N|XSJ CMD 2
44.65|154.13000|110.9|156.12000|156.7|H|N|XSJ CMD 3
44.66|152.35250|100.0|157.58250|D143|H|N|XSJ CMD 6
44.67|154.07000|110.9|154.07000|110.9|L|N|XSJ TAC 7
44.68|154.23500|156.7|154.23500|156.7|L|N|XSJ TAC 8
44.69|159.17250|D565|159.17250|D565|L|N|XSJ TAC 9
44.70|156.24000|D565|156.24000|D565|L|N|XSJ TAC 10
44.71|153.80000|203.5|000.00000|000.0||N|
44.72|152.72000|162.2|000.00000|000.0||N|TUOL SO SONORA PK
44.73|152.72000|162.2|000.00000|000.0||N|TUOL SO DUCKWALL
44.74|152.72000|162.2|000.00000|000.0||N|TUOL SO MOCCASIN
44.75|152.72000|162.2|000.00000|000.0||N|TUOL SO STRAWBERRY
44.76|152.72000|162.2|000.00000|000.0||N|TUOL SO DOUBLE DOME
44.77|152.63000|162.2|000.00000|000.0||N|TUOL SO SONORA PK
44.78|152.63000|162.2|000.00000|000.0||N|TUOL SO DUCKWALL
44.79|152.63000|162.2|000.00000|000.0||N|TUOL SO MOCCASIN
44.80|151.04000|192.8|000.00000|000.0||N|CALAVERAS SO
44.81|151.05500|192.8|000.00000|000.0||N|CALAVERAS SO
44.82|151.43000|000.0|000.00000|000.0||N|DFG BLUE MTN CALAVERAS
44.83|151.41500|000.0|000.00000|000.0||N|DFG MT ELIZABETH
44.84|153.99500|131.8|000.00000|000.0||N|MPSA SO (T1-PENO/T3-BULL)
44.85|168.62500|000.0|168.62500|110.9|L|N|Emergency`;
